import { render } from "./LevelThreeChartOfAccountsCopy1Page.vue?vue&type=template&id=1546fa0b&scoped=true"
import script from "./LevelThreeChartOfAccountsCopy1Page.vue?vue&type=script&lang=js"
export * from "./LevelThreeChartOfAccountsCopy1Page.vue?vue&type=script&lang=js"

import "./LevelThreeChartOfAccountsCopy1Page.vue?vue&type=style&index=0&id=1546fa0b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1546fa0b"]])

export default __exports__